import { useState, useEffect } from 'react';
import { TaskList } from './task-list';
import { KanbanBoard } from './kanban/kanban-board';
import { TaskBoardToolbar } from './task-board-toolbar';
import { useTaskStore } from '@/lib/task-store';

export function TaskBoard() {
  const { tasks, fetchTasks } = useTaskStore();
  const [viewMode, setViewMode] = useState<'list' | 'kanban'>('kanban');
  const [filteredTasks, setFilteredTasks] = useState(tasks);
  const [filters, setFilters] = useState({
    search: '',
    status: '',
    priority: '',
    owner: '',
    person: '', 
    dateRange: {
      start: '',
      end: ''
    }
  });

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  useEffect(() => {
    let result = [...tasks];

    // Apply search filter
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      result = result.filter(task => 
        task.title.toLowerCase().includes(searchLower) ||
        task.description?.toLowerCase().includes(searchLower)
      );
    }

    // Apply status filter
    if (filters.status) {
      result = result.filter(task => task.status === filters.status);
    }

    // Apply priority filter
    if (filters.priority) {
      result = result.filter(task => task.priority === filters.priority);
    }

    // Apply owner filter
    if (filters.owner) {
      result = result.filter(task => task.owner?.id === filters.owner);
    }

    // Apply date filters
    if (filters.dateRange.start || filters.dateRange.end) {
      result = result.filter(task => {
        if (!task.due_date) return false;
        const dueDate = new Date(task.due_date);
        
        if (filters.dateRange.start) {
          const startDate = new Date(filters.dateRange.start);
          if (dueDate < startDate) return false;
        }
        
        if (filters.dateRange.end) {
          const endDate = new Date(filters.dateRange.end);
          if (dueDate > endDate) return false;
        }
        
        return true;
      });
    }

    setFilteredTasks(result);
  }, [tasks, filters]);

  const handleSearch = (value: string) => {
    setFilters(prev => ({ ...prev, search: value }));
  };

  const handleFilterChange = (newFilters: any) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  return (
    <div className="flex flex-col h-full">
      <TaskBoardToolbar
        onSearchChange={handleSearch}
        onFilterChange={handleFilterChange}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />

      <div className="flex-1 overflow-hidden">
        {viewMode === 'list' ? (
          <TaskList 
            tasks={filteredTasks} 
            filters={{
              search: filters.search,
              person: filters.person,
              status: filters.status,
              priority: filters.priority
            }}
          />
        ) : (
          <KanbanBoard tasks={filteredTasks} />
        )}
      </div>
    </div>
  );
}
